import React, {Component} from 'react';
import { Form, InputWrapper } from 'form';

import ReactPhoneInput from 'react-telephone-input';
import flags from '../../../images/flags.png';

import {t} from 'l10n';
import {escape} from 'l10n/utils';

import { Link } from 'components/ReactRouterDomLocalized';
import SubmitWrapper from 'components/form/SubmitWrapper';

import paths from 'paths';

import {updateActivationEmail, requestActivationSms, activateUserByCode} from 'backend-helpers/member';
import {GET_CURRENT_USER} from "reducers/currentUser";
import {connect} from "react-redux";

import '../../../sass/react-tel-input.scss';


class ModalMenuConfirmRegistration extends Component {

    constructor(props) {
        super(props);

        this.state = {
            buttons: true,
            pending: false,
            formEmail: false,
            formPhone: false,
            formConfirm: true,
            email: props.email,
            done: false,
            message: null,
            error: null
        };
        this.changePhone = this.changePhone.bind(this);
        this.onSubmitFormEmail = this.onSubmitFormEmail.bind(this);
        this.onSubmitFormPhone = this.onSubmitFormPhone.bind(this);
        this.onSubmitFormActivateByCode = this.onSubmitFormActivateByCode.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (!this.state.formPhone || prevState.formPhone) return;
        if (typeof window === 'undefined') return;

        let intervalId = null;

        const initCaptcha = () => {
            if (this.captchaRef && window.turnstile) {
                if (this.widgetId !== null) {
                    window.turnstile.remove(this.widgetId);
                    this.widgetId = null;
                }

                this.widgetId = window.turnstile.render(this.captchaRef, {
                    sitekey: '0x4AAAAAACYQvImRXMQ5dwGT',
                    callback: (token) => {
                        this.setState({ captchaToken: token, error: null });
                    },
                    'expired-callback': () => {
                        this.setState({ captchaToken: null });
                    }
                });

                clearInterval(intervalId);
            }
        };

        intervalId = window.setInterval(initCaptcha, 100);

        this._intervalCleanupCaptcha = () => clearInterval(intervalId);
    }

    componentWillUnmount() {
        if (this._intervalCleanupCaptcha) this._intervalCleanupCaptcha();

        if (window.turnstile && this.widgetId !== null) {
            window.turnstile.remove(this.widgetId);
        }
    }

    resetCaptcha() {
        if (!window.turnstile || this.widgetId === null) return;

        window.turnstile.reset(this.widgetId);

        this.setState({
            captchaToken: null
        });
    }

    onSubmitFormEmail(formData, setErrors) {
        if (!this.state.captchaToken) {
            this.setState({ error: t('Please confirm you are not a robot') });
            this.resetCaptcha();
            return;
        }

        this.setState({pending: true, error: false});

        updateActivationEmail(formData).then(() => {
            this.resetCaptcha();
            this.setState({
                pending: false,
                formEmail: false,
                email: formData.email,
                formConfirm: true,
            });
        }).catch((error) => {
            this.resetCaptcha();
            this.setState({
                pending: false,
                error: error.messages || error.message
            });
        });
    }

    changePhone(phone) { this.setState({phone: phone}); }

    onSubmitFormPhone = (formData, setErrors) => {
        if (!this.state.captchaToken) {
            this.setState({error: t('Please confirm you are not a robot')});
            return;
        }

        this.setState({ pending: true, error: false });

        requestActivationSms({
            phone: this.state.phone,
            captcha: this.state.captchaToken
        })
            .then(() => {
                this.setState({
                    pending: false,
                    formPhone: false,
                    formConfirm: true,
                });
                window.turnstile.reset(this.widgetId);
            })
            .catch((error) => {
                this.setState({ pending: false, error });
                window.turnstile.reset(this.widgetId);
            });
    };

    onSubmitFormActivateByCode(formData, setErrors) {
        let {dispatch} = this.props;

        this.setState({pending: true, error: false});

        activateUserByCode(formData).then((response) => {
            this.setState({
                pending: false,
                formConfirm: false,
                buttons: false,
                message: response.message,
                done: true
            });

            dispatch({type: GET_CURRENT_USER});

        }).catch((error) => {
            this.setState({
                pending: false,
                error: error
            });
        });
    }

    actionSendEmail() {
        const { formEmail } = this.state;

        this.setState({
                formPhone: false,
                formEmail: !formEmail
            },
            () => { if(this.emailChangeInput) this.emailChangeInput.focus(); }
        );
    }

    actionSendPhone() {
        const { formPhone } = this.state;

        this.setState({
            formEmail: false,
            formPhone: !formPhone
        });
    }

    render() {
        const {
            pending,
            buttons,
            formEmail,
            formPhone,
            formConfirm,
            done,
            message,
            error,
        } = this.state;

        let email = this.state.email ? this.state.email : (this.props.email ? this.props.email : "");

        return (
            <div className="confirm-registration">
                <p className="name">
                    <span>{t('Activation')}</span>
                    <Link to="/?login" className="header-button">{t('Log in')}</Link>
                </p>

                {!done ?
                    <div className="text-confirm-registration">
                        <p dangerouslySetInnerHTML={{__html:t("Please enter the activation code we sent to your email <span class=\"underline\">%1</span> or clicking the activation link from email message.", escape(email))}}/>
                        <p>{t('If you do not receive this email immediately, check your "spam" folder and mark this as "non-spam".')}</p>
                        <p
                            dangerouslySetInnerHTML={{
                                __html:
                                    t(
                                        "If you can not find this email, activate your account par SMS or %1 so that I manually activate your account.",
                                        <Link href={paths.contact.path} target="_blank">{t('contact me')}</Link>
                                    )
                            }}
                        />
                    </div>
                    : null}

                {done ? (
                    <div className="text-confirm-registration">
                        <p
                            dangerouslySetInnerHTML={{
                                __html: message
                            }}
                        />
                        <p>
                            <Link to="/">{t('You can start using BobTV')}</Link>
                        </p>
                    </div>
                    ) : null }

                {buttons ? (
                    <div className="buttons">
                        <button className={formEmail ? 'active' : null} onClick={() => this.actionSendEmail()}>{t('Change email')}</button>
                        <button className={formPhone ? 'active' : null} onClick={() => this.actionSendPhone()}>{t('Send to phone')}</button>
                    </div>
                    ) : null}

                {formEmail ? (
                    <Form onSubmit={this.onSubmitFormEmail}>
                        <div className="space-between">
                            <input
                                data-formfield={true}
                                name="email"
                                type="email"
                                placeholder="Email"
                                defaultValue={email}
                                ref={(input) => { this.emailChangeInput = input; }}
                            />
                        </div>
                        <div>
                            <SubmitWrapper className="btn-submit" value={t('Send')} pending={pending}/>
                        </div>
                    </Form>
                ) : null}

                {formPhone ? (
                    <Form onSubmit={this.onSubmitFormPhone}>
                        <div className="space-between">
                            <ReactPhoneInput
                                name="phone"
                                defaultCountry="fr"
                                flagsImagePath={flags}
                                onChange={e => this.changePhone(e)}
                            />

                            <div ref={el => (this.captchaRef = el)} style={{margin: '20px 0'}}/>
                        </div>

                        <div>
                            <SubmitWrapper className="btn-submit" value={t('Send')} pending={pending}/>
                        </div>
                    </Form>
                ) : null}


                {!formEmail && !formPhone && !done ? (
                    <Form onSubmit={this.onSubmitFormActivateByCode}>
                        <div className="space-between">
                            <InputWrapper data-formfield={true} name="code" type="text" placeholder="XXXX" maxLength="4" forceHtml/>
                        </div>
                        <div>
                            <SubmitWrapper className="btn-submit" value={t('Send')} pending={pending}/>
                        </div>
                    </Form>
                ) : null}

                {error ?
                    <div className="error-messages">
                        <p dangerouslySetInnerHTML={{
                            __html: error
                        }}
                        />
                    </div>
                    : null}

            </div>
        )
    }

}

export default connect(
    state => ({
        currentUser: state.currentUser
    }),
    null
)(ModalMenuConfirmRegistration);


// WEBPACK FOOTER //
// ./src/components/modals/ModalMenu/ModalMenuConfirmRegistration.js